import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { PerformanceHotelRow } from '../../../domain/corporate/performance-hotel-row';
import { DurationFromDaysPipe } from '../../../pipes/duration-from-days.pipe';
import { SkeletonModule } from 'primeng/skeleton';
import { ButtonDirective } from 'primeng/button';
import { StaffPerformanceRowVm } from '../../../domain/corporate/staff-performance-row-vm';
import { PerformanceHotelStaffInlineDrawerComponent } from '../performance-hotels-panel/performance-hotel-staff-inline-drawer/performance-hotel-staff-inline-drawer.component';

@Component({
   selector: 'app-top-performing-hotels-table',
   standalone: true,
   imports: [
      CommonModule,
      TableModule,
      DurationFromDaysPipe,
      SkeletonModule,
      ButtonDirective,
      PerformanceHotelStaffInlineDrawerComponent
   ],
   templateUrl: './top-performing-hotels-table.component.html',
   styleUrls: ['./top-performing-hotels-table.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopPerformingHotelsTableComponent {
   @Input() rows: PerformanceHotelRow[] = [];
   @Input() loading = false;
   @Input() staffByPropertyId: Map<number, StaffPerformanceRowVm[]> | null = null;
   private expanded = new Set<number>();
   // Optional: use as tooltip raw value
   rawDays(v: number | null | undefined): string {
      if (v === null || v === undefined || Number.isNaN(v) || v <= 0) return '-';
      return `${v.toFixed(2)} days`;
   }

   isExpanded(propertyId: number): boolean {
      return this.expanded.has(propertyId);
   }

   toggleExpand(propertyId: number): void {
      if (this.expanded.has(propertyId)) this.expanded.delete(propertyId);
      else this.expanded.add(propertyId);
   }

   staffRows(propertyId: number): StaffPerformanceRowVm[] {
      return this.staffByPropertyId?.get(propertyId) ?? [];
   }
}
